import {Component, OnDestroy, OnInit} from '@angular/core';
import {VerificationDtzFormDto} from '../shared/dto/verification-dtz-form.dto';
import {CertificateService} from '../shared/services/certificate.service';
import {Subscription} from 'rxjs';
import {NgxSpinnerService} from 'ngx-spinner';
import {StorageService, StorageType} from 'gast-common-ng';
import {Router} from '@angular/router';
import {Html5Qrcode} from 'html5-qrcode';
import {Html5QrcodeCameraScanConfig} from 'html5-qrcode/html5-qrcode';
import {CameraDevice} from 'html5-qrcode/esm/camera/core';
import {ToastrService} from 'ngx-toastr';
import {VerificationDtzFromCertificateDto} from '../shared/dto/verification-dtz-from-certificate.dto';

@Component({
  selector: 'app-verification-dtz-qr-code',
  templateUrl: './verification-dtz-qr-code.component.html',
  styleUrls: ['./verification-dtz-qr-code.component.css']
})
export class VerificationDtzQrCodeComponent implements OnInit, OnDestroy {

  readonly QR_CODE_READER_ID = 'reader';
  private subscription: Subscription = new Subscription();
  isLoading: boolean = false;
  html5QrCode: Html5Qrcode;
  html5QrCodeConfig: Html5QrcodeCameraScanConfig = {fps: 10, qrbox: {width: 500, height: 500}};
  userCameras: CameraDevice[] = [];
  selectedCamera: CameraDevice;
  scanInProgress = false;

  constructor(
    private certificationService: CertificateService,
    private spinnerService: NgxSpinnerService,
    private storageService: StorageService,
    private router: Router,
    private toaster: ToastrService,
  ) {
  }

  ngOnInit() {
    this.html5QrCode = new Html5Qrcode(this.QR_CODE_READER_ID);

    this.subscription = this.certificationService.resultDtzByQrCodeLoaded.subscribe((result: VerificationDtzFromCertificateDto) => {
      if (!result) {
        this.showInvalidQrCodeError();
      } else {
        this.storageService.setItem('VERIFICATION_FORM_QR_CODE', this.mapQrCodeResponseDtoToFormDto(result), StorageType.Local);
        this.router.navigate(['verification-dtz-form'], {queryParams: {'from-qr-code': true}})
          .then(() => window.scrollTo({top: 0}));
      }
      this.isLoading = false;
      this.spinnerService.hide();
    });

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  backToDtzChoice(): void {
    this.router.navigate(['verification-dtz-choice']).then(() => window.scrollTo({top: 0}));
  }

  scan(): void {
    Html5Qrcode.getCameras().then(devices => {
      this.userCameras = devices;
      if (this.userCameras && this.userCameras.length) {
        this.selectedCamera = this.userCameras[0];
        this.startStan();
      }
    }).catch(err => {
      this.toaster.error('Kamera nicht gefunden');
    });
  }

  stopScan(): Promise<void> {
    this.scanInProgress = false;

    return this.html5QrCode.stop();
  }

  private startStan(): void {
    this.html5QrCode.start(
      this.selectedCamera.id,
      this.html5QrCodeConfig,
      (decodedText, decodedResult) => {
        this.stopScan().then(() => this.scanSuccessfully(decodedText));
      },
      (errorMessage) => {
      })
      .then(() => this.scanInProgress = true)
      .catch((err) => {
      });
  }

  cameraChanged(cameraId: string) {
    this.stopScan().then(() => {
      this.selectedCamera = this.userCameras.find(camera => camera.id == cameraId);
      this.startStan();
    });
  }

  scanSuccessfully(decodedText: string): void {

    const data = decodedText.match(/token=(.+)&hash=(\d+)/) || [];

    if (data.length !== 3) {

      this.showInvalidQrCodeError();

    } else {

      this.certificationService.getDtzQrCodeResults(data[1], +data[2]);
    }
  }

  showInvalidQrCodeError(): void {
    this.toaster.error('Ungültiger QR CODE');
  }

  mapQrCodeResponseDtoToFormDto(from: VerificationDtzFromCertificateDto): VerificationDtzFormDto {
    return {
      examDate: from.examDate,
      speakingScore: from.scoreSpeaking,
      dateOfBirth: from.dateOfBirth,
      writingScore: from.scoreWriting,
      maxWritingScore: from.maxWriting,
      fullName: from.fullName,
      listeningAndReadingLevel: `${from.gerLevelReadingAndListening} ${from.gerSublevelReadingAndListening}`,
      listeningAndReadingScore: from.scoreReadingAndListening,
      maxListeningAndReadingScore: from.maxReadingAndListening,
      maxSpeakingScore: from.maxSpeaking,
      overallResult: from.gerTotalLevel,
      participantNumber: from.participantNumber,
      speakingLevel: `${from.gerLevelSpeaking} ${from.gerSublevelSpeaking}`,
      writingLevel: `${from.gerLevelWriting} ${from.gerSublevelWriting}`,
    } as VerificationDtzFormDto;
  }
}
